import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_PERMISE_RESET = 'PUT_PERMISE_RESET';
export const PUT_PERMISE_LOADING = 'PUT_PERMISE_LOADING';
export const PUT_PERMISE_SUCCESS = 'PUT_PERMISE_SUCCESS';
export const PUT_PERMISE_REJECT = 'PUT_PERMISE_REJECT';

//* ACTIONS ------------------------------------------------
export const putPermiseReset = () => ({ type: PUT_PERMISE_RESET });
export const putPermiseLoading = () => ({ type: PUT_PERMISE_LOADING });
export const putPermiseSuccess = (payload) => ({ type: PUT_PERMISE_SUCCESS, payload });
export const putPermiseReject = (payload) => ({ type: PUT_PERMISE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putPermiseRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/Profiles/web/${data.idProfile}`, options);
};


